// extracted by mini-css-extract-plugin
export default {"titleBody":"ManageCar_titleBody__p2jyf","deleteBtn":"ManageCar_deleteBtn__9amn9","cancelBtn":"ManageCar_cancelBtn__yAsYn","deleteCarBtn":"ManageCar_deleteCarBtn__-j7+d"};